// import { Component } from '@angular/core';
// import { SpotService } from 'src/app/services/spot.service';
// import { PairFacade } from 'src/app/store/pair';
// import { CurrencyFacade } from 'src/app/store/currency';
// import { PriceCnvFacade } from 'src/app/store/pricecnv';
// import { UserSettingFacade } from 'src/app/store/usersetting';
// import { UserFacade } from 'src/app/store/user';
// import { WalletFacade } from 'src/app/store/wallet';
// import isEmpty from 'src/app/lib/isEmpty';

// // import lib
// import { toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
// import { WalletService } from 'src/app/services/wallet.service';
// import { Router } from '@angular/router';
// @Component({
//   selector: 'app-wallet',
//   templateUrl: './wallet.component.html',
//   styleUrls: ['./wallet.component.css'],
// })
// export class WalletComponent {
//   toFixedDown = toFixedDown;
//   toFixed = toFixed;
//   truncateDecimals = truncateDecimals

//   search: string = ''
//   pairList: any = {};
//   currency: any = {};
//   usersettings: any = {};
//   wallet: any = {};
//   user: any = {};
//   priceconversion: any = {};
//   Assets: any = {};
//   totalBalance: any = [0];
//   cryptoBalance: number = 0;
//   inrBalance: number = 0;
//   inrCurrency: any = {};
//   url: string = 'spot';
//   loader = false;
//   searchPair: string = '';
//   filteredPairList: any[] = [];

//   selectedCurrencyType: string = 'INR'; // default value
//   searchText: string = '';
//   // Pagination
//   currentPage: number = 1;
//   itemsPerPage: number = 10;

//   usdtOptions = {
//     decimalPlaces: 2,
//     prefix: '$ ',
//     useEasing: true,
//     // duration: 2
//     scrollSpyOnce: true
//   }

//   inrOptions = {
//     decimalPlaces: 2,
//     prefix: '&#8377; ',
//     useEasing: true,
//     // duration: 2
//     scrollSpyOnce: true
//   }

//   constructor(
//     private pairFacade: PairFacade,
//     private currencyFacade: CurrencyFacade,
//     private priceCnvFacade: PriceCnvFacade,
//     private userSettingFacade: UserSettingFacade,
//     private userFacade: UserFacade,
//     private walletFacade: WalletFacade,
//     private service: SpotService,
//     private walletService: WalletService,
//     private router: Router
//   ) { }

//   ngOnInit() {
//     this.userDeposit();
//     this.makeAPICalls();
//     this.getassetData()

//   }

//   makeAPICalls() {
//     this.priceCnvFacade.pricecnv$.subscribe({
//       next: (priceconversionData) => {
//         this.priceconversion = priceconversionData;
//         this.userFacade.user$.subscribe({
//           next: (userData) => {
//             this.user = userData;
//             console.log(userData, 'userData');


//             this.userSettingFacade.usersetting$.subscribe({
//               next: (usersettingData) => {
//                 this.usersettings = usersettingData;

//                 this.service.getPairList().subscribe({
//                   next: (v: any) => {
//                     if (v.success) {
//                       this.pairFacade.setPair(v.result);
//                       this.pairList = v.result;
//                     }

//                     this.currencyFacade.currency$.subscribe({
//                       next: (currencyData) => {
//                         this.currency = currencyData;

//                         this.walletFacade.wallet$.subscribe({
//                           next: (walletData) => {
//                             this.wallet = walletData;
//                             // console.log(walletData, 'walletData');


//                             this.pairFacade.pair$.subscribe({
//                               next: (pairData) => {
//                                 this.pairList = pairData;
//                                 this.assetList();
//                               },
//                               error: (err) => {
//                                 // console.log(err)
//                               },
//                             });
//                           },
//                           error: (err) => {
//                             // console.log(err)
//                           },
//                         });
//                       },
//                       error: (err) => {
//                         // console.log(err)
//                       },
//                     });
//                   },
//                   error: (err) => {
//                     // console.log(err)
//                   },
//                 });
//               },
//               error: (err) => {
//                 // console.log(err)
//               },
//             });
//           },
//           error: (err) => {
//             // console.log(err)
//           },
//         });
//       },
//       error: (err) => {
//         // console.log(err)
//       },
//     });
//   }

//   userDeposit() {
//     this.walletService.userDeposit().subscribe({
//       next: (v: any) => {
//         if (v.success) {
//         }
//       },
//       error: (err: any) => { },
//     });
//   }
//   getPairList() {
//     this.service.getPairList().subscribe({
//       next: (v: any) => {
//         if (v.success) {
//           this.pairFacade.setPair(v.result);
//           this.pairList = v.result;
//         }
//       },
//       error: (err: any) => { },
//     });
//   }

//   handleSearch(event: any): void {
//     this.searchPair = event.target.value.toLowerCase();
//     this.currentPage = 1; // Reset to first page when searching
//   }

//   assetList() {
//     let assetArr = [];
//     let priceCNV;
//     let totalAmount = 0;
//     let inrBalance = 0;
//     let cryptoBalance = 0;

//     if (this.wallet.length > 0 && this.currency.length > 0) {
//       let wallets = this.wallet;

//       for (let item of wallets) {
//         let bal = item.spotBal;
//         let convertPrice = 1

//         if (this.usersettings && this.priceconversion && this.priceconversion.length > 0) {
//           const currencySymbol = this.usersettings.userSetting?.currencySymbol
//           const defaultcurr = currencySymbol == 'USD' ? 'USDT' : currencySymbol

//           if (item.coin != 'USDT') {
//             priceCNV = this.priceconversion.find((el: any) =>
//               el.baseSymbol == item.coin && el.convertSymbol == defaultcurr
//             );
//             convertPrice = parseFloat(priceCNV?.convertPrice)
//           }
//         }

//         let curr = this.currency.find((el: any) => el._id == item._id && el.status == "active");
//         if (!isEmpty(curr)) {
//           const hasTradePair = this.pairList &&
//             this.pairList.find(
//               (pair: any) =>
//                 (pair.status === 'active' &&
//                   pair.firstCurrencySymbol === curr.coin) ||
//                 pair.secondCurrencySymbol === curr.coin
//             );

//           assetArr.push({
//             wallet: item,
//             currency: curr,
//             hasTradePair: hasTradePair,
//           });



//         }

//         if (!isEmpty(curr) && (!isEmpty(priceCNV) || item.coin == 'USDT')) {
//           if (!isEmpty(bal) && bal > 0) {
//             let amount = bal * convertPrice;
//             totalAmount = totalAmount + amount;
//             if (['crypto', 'token'].includes(curr.type)) {
//               cryptoBalance += amount;
//             } else if (curr.type == 'fiat' && curr.coin == 'INR') {
//               inrBalance = bal;
//             }
//           }
//           if (curr.type == 'fiat' && curr.coin == 'INR') {
//             this.inrCurrency = curr
//           }
//         }

//         this.Assets = assetArr;

//       }
//       this.totalBalance = truncateDecimals(totalAmount, 2);
//       this.cryptoBalance = truncateDecimals(cryptoBalance, 2);
//       this.inrBalance = truncateDecimals(inrBalance, 2);
//       this.loader = true
//     }
//   }
//   onCurrencyTypeChange(event: any) {
//     this.selectedCurrencyType = event.target.value;
//     this.loader = false; // Show loader
//     this.getassetData(); // or whatever method you use
//   }
//   newpairList: any = [];
//   getassetData() {
//     this.currencyFacade.currency$.subscribe({
//       next: (currencyArray: any) => {
//         this.currency = currencyArray;
//         const data: any = {
//           // userId: this.user._id,
//           userId: "64d0dba327c69e1220578e66",
//           currencyType: this.selectedCurrencyType,
//         };

//         this.service.getMyInvestedCal(data).subscribe({
//           next: (res: any) => {
//             if (res.status && res.result) {
//               this.newpairList = res.result.map((item: any) => {
//                 const matchedCurrency = this.currency.find((cur: any) => cur.coin === item.firstCurrencySymbol);

//                 let hasTradePair = null;
//                 if (matchedCurrency) {
//                   hasTradePair = this.pairList?.find((pair: any) =>
//                     pair.status === 'active' &&
//                     (pair.firstCurrencySymbol === matchedCurrency.coin || pair.secondCurrencySymbol === matchedCurrency.coin)
//                   );
//                 }

//                 return {
//                   ...item,
//                   depositStatus: matchedCurrency?.depositStatus || 'N/A',
//                   withdrawStatus: matchedCurrency?.withdrawStatus || 'N/A',
//                   image: matchedCurrency?.image || '',
//                   type: matchedCurrency?.type || '',
//                   hasTradePair: hasTradePair || null
//                 };
//               });
//               this.filteredPairList = [...this.newpairList]; // ✅ Initialize filtered list here

//               this.loader = true;
              
//             }
//           },
//           error: (err) => {
//             console.log('Error fetching asset data:', err);
//             this.loader = true;
//           }
//         });
//       },
//       error: (err) => {
//         console.log('Error fetching currency:', err);
//       },
//     });
//   }

//   applyFilter(): void {
//     if (!this.searchText || this.searchText.trim() === '') {
//       this.filteredPairList = [...this.newpairList];
//     } else {
//       const search = this.searchText.toLowerCase();
//       this.filteredPairList = this.newpairList.filter((item: any) =>
//         item.coin?.toLowerCase().includes(search)
//       );
//     }
//   }

//   goToTrade(firstcoin: any , secondcoin:any): void {
//     this.router.navigate([`/spot/${firstcoin}_${secondcoin}`,]);
//   }


// }




import { Component } from '@angular/core';
import { SpotService } from 'src/app/services/spot.service';
import { PairFacade } from 'src/app/store/pair';
import { CurrencyFacade } from 'src/app/store/currency';
import { PriceCnvFacade } from 'src/app/store/pricecnv';
import { UserSettingFacade } from 'src/app/store/usersetting';
import { UserFacade } from 'src/app/store/user';
import { WalletFacade } from 'src/app/store/wallet';
import isEmpty from 'src/app/lib/isEmpty';
import { combineLatest } from 'rxjs';
import { take, map, switchMap, filter } from 'rxjs/operators';


// import lib
import { toFixed, toFixedDown, truncateDecimals } from 'src/app/lib/roundOf';
import { WalletService } from 'src/app/services/wallet.service';
@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.css'],
})
export class WalletComponent {
  toFixedDown = toFixedDown;
  toFixed = toFixed;
  truncateDecimals = truncateDecimals

  search: string = ''
  pairList: any = {};
  currency: any = {};
  usersettings: any = {};
  wallet: any = {};
  user: any = {};
  priceconversion: any = {};
  Assets: any = {};
  totalBalance: any = [0];
  cryptoBalance: number = 0;
  inrBalance: number = 0;
  inrCurrency: any = {};
  url: string = 'spot';
  loader = false;
BotProfit: any;
  OpenOrderValue: any;
  Subscrtiption: any;
  totDeposit: any;
  totWithdraw: any;
totalPNL:any;
  usdtOptions = {
    decimalPlaces: 2,
    prefix: '$ ',
    useEasing: true,
    // duration: 2
    scrollSpyOnce: true
  }
  
  inrOptions = {
    decimalPlaces: 2,
    prefix: '&#8377; ',
    useEasing: true,
    // duration: 2
    scrollSpyOnce: true
  }
  
  constructor(
    private pairFacade: PairFacade,
    private currencyFacade: CurrencyFacade,
    private priceCnvFacade: PriceCnvFacade,
    private userSettingFacade: UserSettingFacade,
    private userFacade: UserFacade,
    private walletFacade: WalletFacade,
    private service: SpotService,
    private walletService: WalletService
  ) { }

  ngOnInit() {
    this.userDeposit();
    this.makeAPICalls();
    // this.getWalletData();
  }
  makeAPICalls() {
    combineLatest([
      this.priceCnvFacade.pricecnv$,
      this.userFacade.user$,
      this.userSettingFacade.usersetting$
    ])
    .pipe(take(1))
    .subscribe({
      next: ([priceconversionData, userData, usersettingData]) => {
        this.priceconversion = priceconversionData;
        this.user = userData;
        this.usersettings = usersettingData;
  
        this.service.getPairList().subscribe({
          next: (v: any) => {
            if (v.success) {
              // Step 1: Set pair list into store
              this.pairFacade.setPair(v.result);
  
              // Step 2: Wait until the pair$ observable reflects the updated data
              this.pairFacade.pair$
                  .pipe(
                    filter(pairList => !!pairList), // Wait for non-empty pair list
                    take(1),
                    switchMap(pairData =>
                      combineLatest([
                        this.currencyFacade.currency$.pipe(
                          filter(currency => Array.isArray(currency) && currency.length > 0),
                          take(1)
                        ),
                        this.walletFacade.wallet$.pipe(
                          filter(wallet => Array.isArray(wallet) && wallet.length > 0),
                          take(1)
                        )
                      ]).pipe(
                        map(([currencyData, walletData]) => ({
                          currencyData,
                          walletData,
                          pairData
                        }))
                      )
                    )
                  )
                  .subscribe({
                    next: ({ currencyData, walletData, pairData }) => {
                      // console.log(currencyData,"currencyData");
                      // console.log(walletData,"walletData");
                      // console.log(pairData,"pairData");
                      this.currency = currencyData;
                      this.wallet = walletData;
                      this.pairList = pairData;

                      this.assetList(); // Proceed only when all required data is ready
                    },
                    error: (err) => console.error('Error fetching currency/wallet/pair data:', err)
                  });

            }
          },
          error: (err) => console.error('Error fetching pair list:', err)
        });
      },
      error: (err) => console.error('Error fetching initial data:', err)
    });
  }
  

  userDeposit() {
    this.walletService.userDeposit().subscribe({
      next: (v: any) => {
        if (v.success) {
        }
      },
      error: (err: any) => { },
    });
  }
  // getPairList() {
  //   this.service.getPairList().subscribe({
  //     next: (v: any) => {
  //       if (v.success) {
  //         this.pairFacade.setPair(v.result);
  //         this.pairList = v.result;
  //       }
  //     },
  //     error: (err: any) => { },
  //   });
  // }


    getWalletData() {
    this.walletService.getWalletDetails().subscribe({
      next: (v: any) => {
        if (v.success) {
         this.BotProfit=v.resp.BotProfit;
         this.OpenOrderValue=v.resp.OpenOrderValue;
         this.Subscrtiption=v.resp.Subscrtiption;
         this.totDeposit=v.resp.totDeposit;
         this.totWithdraw=v.resp.totWithdraw;


        }
      },
      error: (err: any) => { },
    });
  }

  handleSearch(event: any) {
    this.search = event.target.value.toUpperCase().replace('/', '')
  }

  assetList() {
    let assetArr = [];
    let totalAmount = 0;
    let inrBalance = 0;
    let cryptoBalance = 0;
  
    if (this.wallet.length > 0 && this.currency.length > 0) {
      let wallets = this.wallet;
  // console.log(this.wallet.lengt,"this.wallet.lengtthis.wallet.lengtthis.wallet.lengt")
      for (let item of wallets) {
        let bal = item.spotBal;
        let convertPrice = 1;
        let usdtPrice = 0;
        let inrPrice = 0;
  
        if (this.priceconversion && this.priceconversion.length > 0) {
          // Find USDT price for this coin

          // console.log(item.coin,"item.coinitem.coinitem.coin");
          const usdtObj = this.priceconversion.find((el: any) =>
            el.baseSymbol === item.coin && el.convertSymbol === 'USDT'
          );
          if (usdtObj) usdtPrice = parseFloat(usdtObj.convertPrice);
          
          // console.log(this.priceconversion,"this.priceconversion")
          // Find INR price for this coin
          const inrObj = this.priceconversion.find((el: any) => 
            el.baseSymbol === item.coin && el.convertSymbol === 'INR'
          );

        
      
          if (inrObj) inrPrice = parseFloat(inrObj.convertPrice);

          // if(item.coin == "USDT") {
          //   console.log("usdtPriceusdtPriceinrPrice",inrObj,parseFloat(inrObj.convertPrice));
          // }
  
          // Use convert price based on user setting
          const currencySymbol = this.usersettings?.userSetting?.currencySymbol || 'USDT';
          const defaultcurr = currencySymbol === 'USD' ? 'USDT' : currencySymbol;
          


          const selectedObj = this.priceconversion.find((el: any) =>
            el.baseSymbol === item.coin && el.convertSymbol === defaultcurr
          );
          if (selectedObj) convertPrice = parseFloat(selectedObj.convertPrice);
        }

       
  
        let curr = this.currency.find((el: any) => el._id === item._id && el.status === "active");
        if (!isEmpty(curr)) {
          const hasTradePair = this.pairList?.find(
            (pair: any) =>
              pair.status === 'active' &&
              (pair.firstCurrencySymbol === curr.coin || pair.secondCurrencySymbol === curr.coin)
          );
       
          if(item.coin == "USDT") {
            console.log("usdtPriceusdtPriceinrPrice1234567890123",item,curr,usdtPrice,inrPrice);
          }

          assetArr.push({
            wallet: item,
            currency: curr,
            hasTradePair: hasTradePair,
            usdtPrice: usdtPrice || null,
            inrPrice: inrPrice || null,
          });
        }

        assetArr.sort((a, b) => b.wallet.spotBal - a.wallet.spotBal);
  
        if (!isEmpty(curr) && (usdtPrice || item.coin === 'USDT')) {
          if (!isEmpty(bal) && bal > 0) {
            let amount = bal * convertPrice;
            totalAmount += amount;
  
            if (['crypto', 'token'].includes(curr.type)) {
              cryptoBalance += amount;
            } else if (curr.type === 'fiat' && curr.coin === 'INR') {
              inrBalance = bal;
            }
          }
  
          if (curr.type === 'fiat' && curr.coin === 'INR') {
            this.inrCurrency = curr;
          }
        }
      }
  
      this.Assets = assetArr;
      this.totalBalance = truncateDecimals(totalAmount, 2);
      this.cryptoBalance = truncateDecimals(cryptoBalance, 2);
      this.inrBalance = truncateDecimals(inrBalance, 2);
      this.loader = true;
    } else {
      console.log("List Empty");
    }
  }
  
}
